export var reactionVariables = function reactionVariables(siteVars) {
  return {
    meReactingColor: siteVars.colors.brand[400],
    meReactingColorHover: siteVars.colors.brand[300],
    otherReactingColor: siteVars.colors.grey[300],
    otherReactingColorHover: siteVars.colors.white
  };
};
//# sourceMappingURL=reactionVariables.js.map
